import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { suitesData } from '@/data/suitesData';

const Suites = () => {
  const { t } = useLanguage();

  const getSuiteTranslation = (suiteId) => {
    return {
      name: t(`suites.${suiteId}.name`),
      subtitle: t(`suites.${suiteId}.subtitle`),
      description: t(`suites.${suiteId}.description`)
    };
  };

  return (
    <div className="min-h-screen bg-[#f6f6f8] pt-28 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-slide-up" data-testid="suites-header">
          <h1 className="text-5xl font-extrabold mb-6 text-slate-900">{t('suites.title')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('suites.description')}
          </p>
        </div>

        {/* Suites List */}
        <div className="space-y-16">
          {suitesData.map((suite, index) => {
            const translation = getSuiteTranslation(suite.id);
            return (
              <div
                key={suite.id}
                className={`bg-white rounded-2xl shadow-xl overflow-hidden animate-slide-up flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
                style={{ animationDelay: `${index * 0.1}s` }}
                data-testid={`suite-item-${suite.id}`}
              >
                {/* Image */}
                <div className="lg:w-1/2 h-80 lg:h-auto image-hover-zoom">
                  <img
                    src={suite.mainImage}
                    alt={translation.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Content */}
                <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
                  <h2 className="text-3xl font-bold text-slate-900 mb-2">{translation.name}</h2>
                  <p className="text-[#C5A059] font-semibold mb-4">{translation.subtitle}</p>
                  <p className="text-gray-600 mb-6 leading-relaxed">{translation.description}</p>

                  {/* CTA */}
                  <Link
                    to={`/suite/${suite.id}`}
                    className="inline-flex items-center justify-center gap-2 btn-gold rounded-lg px-6 py-3 font-bold w-full lg:w-auto"
                    data-testid={`suite-detail-button-${suite.id}`}
                  >
                    {t('suites.viewDetails')}
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-white rounded-2xl p-12 shadow-xl" data-testid="suites-cta">
          <h3 className="text-3xl font-bold text-slate-900 mb-4">
            {t('suites.needHelp')}
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            {t('suites.needHelpDesc')}
          </p>
          <a
            href={`https://wa.me/5531991640648?text=${encodeURIComponent(t('whatsapp.helpChoosing'))}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 btn-gold rounded-lg px-8 py-3 font-bold"
            data-testid="suites-contact-button"
          >
            {t('suites.talkOnWhatsApp')}
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Suites;
